export default "__VITE_ASSET__BCoTEpQ8__"